/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @stylistic/no-mixed-operators */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import jsPDF from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
// eslint-disable-next-line import/no-extraneous-dependencies

import { toast } from 'react-toastify';
import GetQuotePDFBase64 from './GetQuotePDFBase64';
import Button from '../../Parts/Button';
import { useAssembliesByQuoteId } from '../../Store/entities/assemblies/hooks';
import {
	UseMultipliersByQuoteId,
	useQuoteById,
	useQuotePricing,
	useQuoteTypeNameByQuoteId
} from '../../Store/entities/quotes/hooks';
import { useQuoteAccessories } from '../../Store/entities/accessories/hooks';
import { useQuoteAwnings } from '../../Store/entities/awnings/hooks';
import { getAwningParamValue } from '../awningConfiguratorUtils';
import { useHWRItemsByQuoteId } from '../../Store/entities/hardwareRequestItems/hooks';
import { useQuoteFabricSamplesByQuoteId } from '../../Store/entities/fabricSamples/hooks';
import { useUserData } from '../../hooks';
import { useQuoteDemoReview } from '../../Store/entities/quoteDemoReviews/hooks';
import { useDealerById, useDistributorById, useTerritories } from '../../Store/entities/hooks';

applyPlugin(jsPDF);

type PrintQuoteNewProps = {
	quoteId: number;
	hasErrors: boolean;
};

type PrintQuoteNewState = {
	open: boolean;
	type: 'dealer' | 'MSRP' | 'distributor';
	initialBase64: string;
	currentBase64: string;
	generated_by_name: string;
	currency: string;
	couponStatus: 'percentage' | 'fixed' | 'none' | 'hidden';
	taxStatus: 'hidden' | 'visible';
	adjustment: any;
	color: string;
	adjustmentName: string;
	includeWarranty: boolean;
};

function downloadURI(uri, name) {
	let link: HTMLAnchorElement | null = document.createElement('a');
	link.download = name;
	link.href = uri;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	link = null;
}

const PrintQuoteNew = ({ quoteId, hasErrors }: PrintQuoteNewProps) => {
	const multipliers = UseMultipliersByQuoteId(quoteId);
	const currentMultiplier = multipliers?.list?.find((m) => m.name === multipliers.currentMultiplier);

	const userData = useUserData();
	const isPurchasing
		= userData?.roles?.some((r) => r?.role_name?.includes('dealer_purchasing')) ?? false;
	const [state, setStateR] = React.useState<PrintQuoteNewState>({
		open: false,
		type: isPurchasing ? 'dealer' : 'MSRP',
		initialBase64: "Loading...",
		currentBase64: "Loading...",
		generated_by_name: '',
		currency: currentMultiplier?.currency ?? 'USD',
		couponStatus: 'hidden',
		taxStatus: 'visible',
		adjustment: null,
		color: 'green-button',
		adjustmentName: "Adjustment",
		includeWarranty: true
	});
	const setState = (newState) => setStateR({ ...state, ...newState });

	const shadeAssemblies = useAssembliesByQuoteId(quoteId);
	const quoteAwnings = useQuoteAwnings(quoteId);
	const quoteAccessories = useQuoteAccessories(quoteId);
	const hardwareRequestItems = useHWRItemsByQuoteId(quoteId);
	const fabricSamples = useQuoteFabricSamplesByQuoteId(quoteId);

	const quotePricing = useQuotePricing(quoteId);
	const shipping = quotePricing?.total_shipping_price;

	const quote = useQuoteById(quoteId);

	const dealer = useDealerById(quote?.dealer_id ?? 0);
	const distributor = useDistributorById(quote?.distributor_id ?? 0);

	const hasDealer = (quote?.dealer_id ?? 0) > 0;
	const hasDistributor = (quote?.distributor_id ?? 0) > 0;
	const showDistributorOption = !hasDealer && hasDistributor;

	const dealerMultiplier = multipliers?.list?.find((m) => m.name.includes("Dealer"))
	?? multipliers?.list?.find((m) => m.name.includes("My Price"));

	const dealerPricing = useQuotePricing(quoteId, dealer?.multiplier ?? dealerMultiplier?.multiplier ?? 0.5);

	const distributorMultiplierObj = multipliers?.list
		?.find((m) => m.name.includes("Distributor"));
	const distMultiplier = distributor?.pricing_multiplier
		?? distributorMultiplierObj?.multiplier ?? 0.425;
	const distributorPricing = useQuotePricing(quoteId, distMultiplier);

	const demoReviewObj = useQuoteDemoReview(quoteId);
	
	const territories = useTerritories();

	useEffect(() => {
		if (showDistributorOption && state.type === 'dealer') {
			setStateR((prev) => ({ ...prev, type: 'distributor' }));
		} else if (!showDistributorOption && state.type === 'distributor') {
			setStateR((prev) => ({ ...prev, type: isPurchasing ? 'dealer' : 'MSRP' }));
		}
	}, [showDistributorOption]);

	const toggleWarranty = async () => {
		setState(({
			...state,
			includeWarranty: !state.includeWarranty,
		}));
	};

	const { open, currentBase64, type, currency, couponStatus, taxStatus, adjustment, includeWarranty }
		= state;

	const openPage = () => {
		if (hasErrors) {
			toast.error("Please fix the errors before printing the quote.");
			return;
		}
		setState({ open: true });
	};

	const isSalesPerson
		= userData?.roles?.some((r) => r?.role_name?.includes('dealer_salesperson')) ?? false;

	// /overflow: auto; width: 100%; height: 100%;

	const setType = (option) => {
		setState({ type: option });
	};

	const currencyOptions = [
		{
			value: 'CAD',
			display: 'CAD',
		},
		{
			value: 'USD',
			display: 'USD',
		},
	];

	const couponOptions = [
		{
			value: 'percentage',
			display: 'Percentage',
			title: 'This gives the MSRP a percentage equvilent of the coupon.',
		},
		{
			value: 'fixed',
			display: 'Fixed Amount',
			title: 'This gives the MSRP the same discount dollar for dollar as the coupon does.',
		},
		{
			value: 'none',
			display: 'None',
			title: "This doesn't apply the coupon to the MSRP.",
		},
		{
			value: 'hidden',
			display: 'Hidden',
			title: 'This hides the coupon.',
		},
	];

	const taxOptions = [
		{
			value: 'hidden',
			display: 'Hidden',
			title: 'This hides the tax value.',
		},
		{
			value: 'visible',
			display: 'Visible',
			title: 'This shows the tax value.',
		},
	];

	const showCoupon = quote.coupon_snapshot !== 0 || demoReviewObj?.demo_review_status === 'approved';

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const setCurrency = (option) => {
		setState({ currency: option });
	};
	const setAdjustment = (number) => {
		if (number === false) {
			setState({ adjustment: null, adjustmentName: "Adjustment" });
		} else if (number === true) {
			setState({ adjustment: 0, adjustmentName: "Adjustment" });
		} else {
			setState({ adjustment: number });
		}
	};

	const [adjNameState, setAdjNameState] = useState(state.adjustmentName);

	useEffect(() => {
		const handler = setTimeout(() => {
			setStateR((prev) => ({ ...prev, adjustmentName: adjNameState }));
		}, 500);

		return () => {
			clearTimeout(handler);
		};
	}, [adjNameState]);

	const setCoupon = (option) => {
		setState({ couponStatus: option });
	};
	const setTax = (option) => {
		setState({ taxStatus: option });
	};

	const showTaxes = (quote?.sales_tax_percentage_snapshot ?? 0) > 0;

	if (!quotePricing) return <div>Loading...</div>;

	const asyncWrapper = async (callback) => {
		const setBase64 = (base64) => {
			setState(({ ...state, currentBase64: base64, initialBase64: base64 }));
		};

		// apiCalls.getQuotePricing(quoteId).then((response) => {
		// 	setLocalQuoteTotals(response.data.pricing);
		// });

		const priceData = quotePricing;

		const taxPercent = priceData?.tax_rate;

		const { name } = userData ?? { name: '' };

		const generated_by_name = `${name}`;

		const { type, currency, couponStatus, taxStatus, adjustment, adjustmentName, includeWarranty } = state;

		const subtotal = Number((priceData.total_price).toFixed(2));

		const hwRequestItemsToSend = Object.values(hardwareRequestItems).map((item) => ({
			...item,
			quantity: item.quantity ?? 0,
			msrp: (item.msrp ?? 0) * (item.quantity ?? 0),
		}));

		const quoteAccessoriesToSend = [
			...quoteAccessories,
			...hwRequestItemsToSend
		];

		const propertyAddress = quote.property_address;

		const installationAddress = {
			street: `${propertyAddress?.address ?? ''} ${propertyAddress?.address2 ?? ''}`,
			company: propertyAddress?.company_name ?? '',
			city: propertyAddress?.city ?? '',
			state: propertyAddress?.state ?? '',
			zip: propertyAddress?.zip ?? '',
			country: propertyAddress?.country ?? '',
			contact: `${propertyAddress?.first_name ?? ''} ${propertyAddress?.last_name ?? ''}`,
			email: propertyAddress?.email ?? '',
			phone: propertyAddress?.phone ?? '',
		};

		let demoAmount = 0;

		if (demoReviewObj) {
			const reviewStatus = demoReviewObj?.demo_review_status;

			const reviewType = demoReviewObj?.name;
			const inputValue = demoReviewObj?.value ?? 0;

			const approvalTypes = {
				CASH_OVERRIDE: 'cash',
				PERCENTAGE_DECREASE: 'percentage',
				REJECT_DEMO: 'reject',
				DEMO_DEFAULT: 'default',
			};

			let previousMSRP = quotePricing?.subtotal ?? 0;
			previousMSRP -= quotePricing?.total_shipping_price ?? 0;

			let newMsrp
				= approvalTypes.CASH_OVERRIDE === reviewType
					? inputValue
					: approvalTypes.PERCENTAGE_DECREASE === reviewType
						|| approvalTypes.DEMO_DEFAULT === reviewType
						? previousMSRP * (1 - inputValue / 100)
						: previousMSRP * (1 - 0.2 / 100);

			if (reviewStatus === 'approved' && demoReviewObj) {
				newMsrp = (demoReviewObj?.review_description !== 'cash')
					? (previousMSRP * (1 - (demoReviewObj.value ?? 0) / 100))
					: ((demoReviewObj.value ?? 0) * (dealerMultiplier?.currency_multiplier ?? 1));
			}

			newMsrp += quotePricing?.total_shipping_price ?? 0;

			const activePricing = type === 'distributor' ? distributorPricing : dealerPricing;
			demoAmount = (activePricing?.subtotal ?? 0) - newMsrp;
		}

		const couponAmount
			= quotePricing.coupon_total !== 0 ? quotePricing.coupon_total : demoAmount;

		
			
		const quoteDataToSend = {
			id: quoteId,
			title: quote.title ?? "(No Title Entered)",
			generated_by: generated_by_name,
			subtotal,
			dealer_subtotal: Number((dealerPricing?.total_price ?? subtotal).toFixed(2)),
			distributor_subtotal: Number((distributorPricing?.total_price ?? subtotal).toFixed(2)),
			shipping,
			taxPercentage: taxPercent,
			taxShipping: quotePricing.is_shipping_taxable,
			customer_address: { ...installationAddress },
			couponAmount,
			couponType: couponStatus,
			taxType: taxStatus,
			adjustment,
			adjustmentName,
			isShippingTaxed: quotePricing.is_shipping_taxable
		};

		const ontario = territories.find((t) => t.name === 'Ontario')
			?? territories.find((t) => t.iso_4217_currency_code_sell === 'CAD');
		const MINK = territories.find((t) => t.name === 'MINK')
			?? territories.find((t) => t.iso_4217_currency_code_sell === 'USD');

		const currencyData
			= currency === 'CAD'
				? {
					currencyMultiplier: ontario?.msrp_multiplier ?? 1.5,
					currencySymbol: '$',
					currencyISO: ontario?.iso_4217_currency_code_sell ?? "CAD",
				}
				: {
					currencyMultiplier: MINK?.msrp_multiplier ?? 1.0,
					currencySymbol: '$',
					currencyISO: MINK?.iso_4217_currency_code_sell ?? "USD",
				};

		const shadeAssembliesToSend = shadeAssemblies.map((sa) => {
			const firstShade = sa.shades.find(() => true) ?? {
				width: 0,
				height: 0,
			};

			const assembly = {
				room_name: sa.room_name,
				shade_name: sa.shade_name,
				width: sa.is_coupled ? sa.total_width : firstShade?.width,
				height: firstShade?.height,
				fabric: "",
				msrp: 0
			};

			const isDual = sa.single_dual === 'Dual';

			const fabric1 = sa.shades.find((s) => s.row_coordinate === 0)?.fabric_name;
			const fabric2 = sa.shades.find((s) => s.row_coordinate === 1)?.fabric_name;

			assembly.fabric = isDual ? `${fabric1}-${fabric2}` : `${fabric1}`;
			assembly.msrp = sa.msrp;

			return assembly;
		});

		// Awnings live in their own store, so they need their own page on the printed quote --
		// they never show up in the shade assemblies or the accessories.
		const awningsToSend = [...quoteAwnings]
			.sort((a1, a2) => a1.line_number - a2.line_number)
			.map((awning) => ({
				room_name: awning.room_name ?? '',
				awning_name: awning.shade_name || awning.name || 'Awning',
				fabric: getAwningParamValue(awning.parameters, 'colorName'),
				width: getAwningParamValue(awning.parameters, 'width'),
				projection: getAwningParamValue(awning.parameters, 'projection'),
				frame_color: getAwningParamValue(awning.parameters, 'frameColor'),
				mounting: getAwningParamValue(awning.parameters, 'mountingOption'),
				msrp: awning.msrp,
				dealer_sale_price: awning.dealer_sale_price ?? 0,
				base_sale_price: awning.base_sale_price ?? 0,
			}));

		// Changing data here to correct the display for non-USD Dealers
		quoteDataToSend.adjustment /= currencyData.currencyMultiplier;

		const dealerData = {
			company: dealer?.name ?? "",
			contact: `${dealer?.billing_address?.first_name ?? ""} ${dealer?.billing_address?.last_name ?? ""}`,
			street: dealer?.billing_address?.address ?? "",
			email: dealer?.email ?? "",
			city: dealer?.billing_address?.city ?? "",
			phone: dealer?.phone ?? "",
			state: dealer?.billing_address?.state ?? "",
			zip: dealer?.billing_address?.zip ?? "",
			country: dealer?.billing_address?.country ?? "",
			multiplier: dealer?.multiplier ?? 1.0,
		};

		const distAddr = distributor?.billing_address;
		const distributorData = {
			company: distributor?.name ?? "",
			contact: `${distAddr?.first_name ?? ""} ${distAddr?.last_name ?? ""}`,
			street: distAddr?.address ?? "",
			email: distributor?.email ?? "",
			city: distAddr?.city ?? "",
			phone: distributor?.phone ?? "",
			state: distAddr?.state ?? "",
			zip: distAddr?.zip ?? "",
			country: distAddr?.country ?? "",
			multiplier: distributor?.pricing_multiplier ?? 0.425,
		};

		GetQuotePDFBase64({
			shadeAssemblies: shadeAssembliesToSend,
			awnings: awningsToSend,
			quoteAccessories: quoteAccessoriesToSend,
			fabricSamples,
			quoteData: quoteDataToSend,
			type,
			dealerData,
			distributorData,
			currencyData,
			includeWarranty
		}).then((data) => {
			setBase64(data);
			callback && callback();
		});
	};

	useEffect(() => {
		if (open) {
			asyncWrapper(() => {
				// Callback after base64 is set
			});
		}
	}, [
		open,
		quoteAwnings.length,
		state.adjustment,
		state.type,
		state.currency,
		state.adjustmentName,
		state.couponStatus,
		state.includeWarranty,
		state.taxStatus
	]);

	return (
		<>
			<Popup
				open={open}
				onClose={() => setState({ open: false, includeWarranty: false })}
				className="mobile-modal "
			>
				<Container className="local-bootstrap ">
					<Row>
						<Col className="me-2 ms-2">
							<Row className="mb-4">
								<Col xs={12}>
									<h4 className={`text-${quoteType}`}>Print Type</h4>
								</Col>
								<Col>
									<select
										value={type}
										className="form-select"
										onChange={(e) => setType(e.target.value)}
									>
										<option value="msrp">Customer</option>
										{!isSalesPerson && showDistributorOption
											? <option value="distributor">Distributor</option>
											: null}
										{!isSalesPerson && !showDistributorOption
											? <option value="dealer">Dealer</option>
											: null}
									</select>
								</Col>
							</Row>
							<Row className="mb-4">
								<Col xs={12}>
									<h4 className={`text-${quoteType}`}>Currency</h4>
								</Col>
								<Col>
									<select
										value={currency}
										onChange={(e) => setCurrency(e.target.value)}
										className="form-select"
									>
										{currencyOptions.map((o) => (
											<option key={o.value} value={o.value}>
												{o.display}
											</option>
										))}
									</select>
								</Col>
							</Row>
							<Row className="mb-4">
								<Col>
									<Row>
										<Col className="mb-2" xs={12}>
											<Button
												radioButton
												color={adjustment !== null ? quoteType : 'gray'}
												fluid
												fullWidth
												onClick={() => setAdjustment(adjustment === null)}
											>
												Adjustment &nbsp;
												{
													adjustment !== null
														? (<FontAwesomeIcon icon={faCheck} />)
														: (<FontAwesomeIcon icon={faTimes} />)
												}
											</Button>
										</Col>
										<Col>
											<Row>
												<Col xs={6}><span className="text-muted">Description</span></Col>
												<Col xs={6}><span className="text-muted">Amount</span></Col>
											</Row>
											<Row>
												<Col xs={6}>
													<input
														className="form-control"
														disabled={adjustment === null}
														value={adjNameState}
														type="text"
														onChange={(e) => setAdjNameState(e.target.value)}
													/>
												</Col>
												<Col xs={6}>
													<input
														className="form-control"
														disabled={adjustment === null}
														value={adjustment}
														type="number"
														onChange={(e) => setAdjustment(e.target.value)}
													/>
												</Col>
											</Row>
										</Col>
									</Row>
								</Col>
							</Row>

							{showCoupon ? (
								<Row className="mb-4">
									<Col xs={12}>
										<h4 className={`text-${quoteType}`}>Coupon</h4>
									</Col>
									<Col>
										<select
											value={couponStatus}
											onChange={(e) => setCoupon(e.target.value)}
											className="form-select"
										>
											{couponOptions.map((o) => (
												<option key={o.title} title={o.title} value={o.value}>
													{o.display}
												</option>
											))}
										</select>
									</Col>

								</Row>
							) : null}
							{showTaxes ? (
								<Row className="mb-4">
									<Col xs={12}>
										<h4 className={`text-${quoteType}`}>Taxes</h4>
									</Col>
									<Col>
										<select
											value={taxStatus}
											onChange={(e) => setTax(e.target.value)}
											className="form-select"
										>
											{taxOptions.map((o) => (
												<option key={o.value} title={o.title} value={o.value}>
													{o.display}
												</option>
											))}
										</select>
									</Col>

								</Row>
							) : null}
							<Row className="mb-4">
								<Col>
									<Button
										radioButton
										color={includeWarranty ? "green" : "gray"}
										fluid
										fullWidth
										onClick={toggleWarranty}
									>
										Include Warranty Info &nbsp;
										{
											includeWarranty
												? (<FontAwesomeIcon icon={faCheck} />)
												: (<FontAwesomeIcon icon={faTimes} />)
										}
									</Button>
								</Col>
							</Row>
						</Col>
						<Col>
							<embed
								style={{
									overflow: 'auto',
									width: '100%',
									height: '100%',
								}}
								className="pdf"
								src={`${currentBase64}#toolbar=0`}
							/>
						</Col>
					</Row>
					<Row className="align-bottom mt-4">
						<Col>
							<Button
								color="gray"
								onClick={() => setState({ open: false })}
							>
								Close
							</Button>
						</Col>

						<Col className="text-end">
							<Button
								color={quoteType ?? 'green'}
								onClick={() => downloadURI(currentBase64, `PS${quoteId}.pdf`)}
							>
								Download
							</Button>
						</Col>
					</Row>
				</Container>
			</Popup>
			<Button color={quoteType ?? 'green'} fluid fullWidth onClick={() => openPage()}>
				Print Quote
			</Button>
		</>
	);
};

export default PrintQuoteNew;
